/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
  Button,
  Badge,
} from "reactstrap";
import { Link } from "react-router-dom";
// Formik


//Import Breadcrumb
import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "../../Components/Common/TableContainer";
import { deleteUser, listUser } from "./_requests";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useProfile } from "../../Components/Hooks/UserHooks";
import { formatDate } from "../../helpers/FunctionHelpers";
import { useDownloadExcel } from "react-export-table-to-excel";
import jsPDF from "jspdf";
import "jspdf-autotable";

const User = (data: any) => {
  const [User, setUser] = useState<any>([]);
  const [Useraccess, setrolecaccess] = useState<any>([]);
  const { userProfile } = useProfile();
  const [modal, setModal] = useState<boolean>(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
  const [addressModal, setAddressModal] = useState<boolean>(false);
  const [selectedUserAddresses, setSelectedUserAddresses] = useState<any[]>([]);
  const [selectedUserName, setSelectedUserName] = useState<string>("");
  const [UserToDeleteId, setUserToDeleteId] = useState<string>("");
  const [UserToDeleteName, setUserToDeleteName] = useState<string>("");
  const [Duplicate, setDuplicate] = useState<any>("");
  const tableRef = useRef<HTMLTableElement>(null);

  const toggle = useCallback(() => {
    setModal(!modal);
    setDuplicate("");
  }, [modal]);

  const toggleAddressModal = useCallback(() => {
    setAddressModal(!addressModal);
  }, [addressModal]);

  const showAddresses = (user: any) => {
    setSelectedUserAddresses(user.addressBooks || []);
    setSelectedUserName(user.name);
    toggleAddressModal();
  };

  useEffect(() => {
    // getCRUD(userProfile?.role).then((res: any) => {
    //   setrolecaccess(res.Data[0]);
    // });
  }, []);

  const toggleDeleteModal = useCallback(() => {
    setDeleteModalOpen(!deleteModalOpen);
  }, [deleteModalOpen]);

  useEffect(() => {
    fetchUser();
  }, []);

  const fetchUser = () => {
    listUser().then((res: any) => {
      setUser(res);
    });
  };

  // Delete Data
  const onClickDelete = useCallback(
    (User: any) => {
      setUserToDeleteName(User.name);
      setUserToDeleteId(User.id);

      setrolecaccess((prevDepAccess: any) => {
        // if (prevDepAccess?.remove === 1) {
        toggleDeleteModal();
        // } else {
        //   toast.error("You don't have permission to access this page", {
        //     position: "top-right",
        //     style: {
        //       backgroundColor: "#9b2313",
        //       color: "#c7c7d7",
        //       fontSize: "14px",
        //     },
        //     closeButton: false,
        //   });
        // }
        return prevDepAccess;
      });
    },
    [setUserToDeleteName, setUserToDeleteId, toggleDeleteModal]
  );

  const isNewCustomer = (user: any) => {
    if (!user) return false;
    if (user.is_new_customer) return true;
    if (user.is_trial_used === 0 || user.is_trial_used === false) return true;
    if (user.created_at) {
      const diffDays = (new Date().getTime() - new Date(user.created_at).getTime()) / (1000 * 3600 * 24);
      if (diffDays <= 30) return true;
    }
    return false;
  };

  const confirmDelete = async (UserId: any) => {
    await deleteUser(UserId);
    toggleDeleteModal();
    toast.success("User deleted Successfully", { autoClose: 3000 });
    fetchUser();
  };

  // Users Column
  const columns = useMemo(
    () => [
      {
        header: "S.No",
        id: "sno",
        enableColumnFilter: false,
        cell: (cellProps: any) => {
          return (
            cellProps.table.getSortedRowModel().flatRows.indexOf(cellProps.row) + 1
          );
        },
      },
      {
        header: "Name",
        accessorKey: "name",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0 me-3">
                <div className="avatar-sm bg-light rounded p-1">
                  <img
                    src={cell.row.original.profile}
                    alt=""
                    className="img-fluid d-block"
                  />
                </div>
              </div>
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1 d-flex align-items-center flex-wrap gap-1">
                  <Link
                    to={`/user/view/${cell.row.original.id}`}
                    className="custom-redirect-link"
                  >
                    {cell.getValue()}
                  </Link>
                  {isNewCustomer(cell.row.original) && (
                    <Badge color="success" className="badge-soft-success ms-1 fs-11">
                      New
                    </Badge>
                  )}
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        header: "Customer ID",
        accessorKey: "customer_code",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <>
            <div className="d-flex align-items-center">
              {cell.getValue() || "-"}
            </div>
          </>
        ),
      },
      {
        header: "Referral Code",
        accessorKey: "referral_code",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <>
            <div className="d-flex align-items-center fw-bold text-success">
              {cell.getValue() || "-"}
            </div>
          </>
        ),
      },
      {
        header: "Phone No",
        accessorKey: "mobile_number",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <>
            <div className="d-flex align-items-center">
              {cell.getValue() || "-"}
            </div>
          </>
        ),
      },
      {
        header: "Email",
        accessorKey: "email",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <>
            <div className="d-flex align-items-center">
              {cell.getValue() || "-"}
            </div>
          </>
        ),
      },
      {
        header: "State",
        accessorKey: "state",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <>
            <div className="d-flex align-items-center">
              {cell.getValue() || "-"}
            </div>
          </>
        ),
      },
      {
        header: "Pincode",
        accessorKey: "postal_code",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <>
            <div className="d-flex align-items-center">
              {cell.getValue() || "-"}
            </div>
          </>
        ),
      },
      {
        header: "Address",
        accessorKey: "addressBooks",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const addresses = cell.getValue() || [];
          return (
            <div className="d-flex align-items-center">
              <Link
                to="#"
                className="text-primary fw-bold"
                onClick={(e) => {
                  e.preventDefault();
                  showAddresses(cell.row.original);
                }}
              >
                {addresses.length} {addresses.length === 1 ? "Address" : "Addresses"}
              </Link>
            </div>
          );
        },
      },
      {
        header: "Joined Date",
        accessorKey: "created_at",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <div className="d-flex align-items-center">
            {formatDate(cell.getValue()) || "-"}
          </div>
        ),
      },

      {
        header: "Action",
        cell: (cellProps: any) => {
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item edit" title="Edit">
                <Link
                  to={`/user/view/${cellProps.row.original.id}`}
                  className="text-primary d-inline-block edit-item-btn"
                >
                  <i className="ri-eye-fill fs-16"></i>
                </Link>
              </li>
              <li className="list-inline-item" title="Remove">
                <Link
                  to="#"
                  className="text-danger d-inline-block remove-item-btn"
                  onClick={() => {
                    const UserData = cellProps.row.original;
                    onClickDelete(UserData);
                  }}
                >
                  <i className="ri-delete-bin-5-fill fs-16"></i>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ],
    [onClickDelete]
  );

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Users_List",
    sheet: "Users",
  });

  const exportPDF = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);

    const title = "Users List";
    const headers = [["S.No", "Name", "Customer ID", "Phone No", "Email", "State", "Pincode"]];

    const dataRows = User.map((elt: any, index: number) => [
      index + 1,
      elt.name,
      elt.customer_code || "-",
      elt.mobile_number || "-",
      elt.email || "-",
      elt.state || "-",
      elt.postal_code || "-"
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: dataRows,
    };

    doc.text(title, marginLeft, 40);
    (doc as any).autoTable(content);
    doc.save("Users_List.pdf");
  };

  document.title = " Paal Dappa | Admin panel";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="User" pageTitle="Dashboard" />
          <Row>
            <Col lg={12}>
              <Card id="UserList">
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">User List</h5>
                      </div>
                    </div>
                    <div className="col-sm-auto">
                      <div className="d-flex gap-1 flex-wrap">
                        <button
                          type="button"
                          className="btn btn-primary add-btn"
                          onClick={() => onDownload()}
                        >
                          <i className="ri-file-excel-2-line align-bottom me-1"></i>{" "}
                          Export Excel
                        </button>
                        <button
                          type="button"
                          className="btn btn-secondary add-btn"
                          onClick={() => exportPDF()}
                        >
                          <i className="ri-file-pdf-line align-bottom me-1"></i>{" "}
                          Export PDF
                        </button>
                      </div>
                    </div>
                  </Row>
                </CardHeader>
                <div style={{ display: "none" }}>
                  <table ref={tableRef}>
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Name</th>
                        <th>Customer ID</th>
                        <th>Phone No</th>
                        <th>Email</th>
                        <th>State</th>
                        <th>Pincode</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(User || []).map((elt: any, index: number) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{elt.name}</td>
                          <td>{elt.customer_code || "-"}</td>
                          <td>{elt.mobile_number || "-"}</td>
                          <td>{elt.email || "-"}</td>
                          <td>{elt.state || "-"}</td>
                          <td>{elt.postal_code || "-"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="card-body pt-0">
                  <div>
                    <TableContainer
                      columns={columns}
                      data={User || []}
                      isGlobalFilter={true}
                      customPageSize={10}
                      divClass="table-responsive table-card mb-3"
                      tableClass="align-top table-bordered align-top table-nowrap mb-0"
                      SearchPlaceholder="Search User..."
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </div>
              </Card>
            </Col>
          </Row>

          <Modal isOpen={addressModal} toggle={toggleAddressModal} size="lg" centered>
            <ModalHeader toggle={toggleAddressModal}>
              Active Addresses for {selectedUserName}
            </ModalHeader>
            <ModalBody>
              <div className="table-responsive">
                <Table bordered hover className="align-middle mb-0">
                  <thead className="table-light text-primary fw-bold">
                    <tr>
                      <th>#</th>
                      <th>Type</th>
                      <th>Address</th>
                      <th>Coordinates</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedUserAddresses.length > 0 ? (
                      selectedUserAddresses.map((address, index) => (
                        <tr key={address.id}>
                          <td>{index + 1}</td>
                          <td className="fw-medium text-primary">{address.address_type}</td>
                          <td>
                            <div className="d-flex flex-column">
                              <span className="fw-semibold">{address.address}</span>
                              <span className="small text-muted">{address.city}, {address.state} - {address.postal_code}</span>
                            </div>
                          </td>
                          <td>
                            {(address.latitude || address.longitude) ? (
                              <div className="text-info small">
                                <i className="ri-map-pin-fill me-1"></i>
                                Lat: {address.latitude}<br />
                                Long: {address.longitude}
                              </div>
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="text-center">No active addresses found</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={toggleAddressModal}>
                Close
              </Button>
            </ModalFooter>
          </Modal>

          <Modal isOpen={deleteModalOpen} toggle={toggleDeleteModal} centered>
            <ModalHeader toggle={toggleDeleteModal}>
              Confirm Deletion
            </ModalHeader>
            <ModalBody>
              Are you sure you want to delete the User{" "}
              <strong>{UserToDeleteName}</strong>?
            </ModalBody>
            <ModalFooter>
              <Button
                className="btn text-white add-btn me-1"
                style={{
                  backgroundColor: "#28a8df",
                  borderColor: "#28a8df",
                }}
                onClick={toggleDeleteModal}
              >
                Cancel
              </Button>
              <Button
                className="btn text-white add-btn me-1"
                style={{
                  backgroundColor: "#28a8df",
                  borderColor: "#28a8df",
                }}
                onClick={() => {
                  confirmDelete(UserToDeleteId);
                  setModal(false);
                }}
              >
                Delete
              </Button>
            </ModalFooter>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default User;
